import React from "react";
import {
  t,
  BID_SEC_P1,
  BID_SEC_LI1,
  BID_SEC_LI2,
  BID_SEC_LI3,
  BID_SEC_LI4,
  BID_SEC_LI5,
  BID_SEC_LI6,
  BID_SEC_LI7,
  BID_SEC_LI8,
} from "../../translations/AboutUs/SutpIts";

function BidSection() {
  return (
    <div class="main-container Itsmc">
      <div class="main-header">{t(BID_SEC_P1)}</div>
      <div class="report-item-list">
        <ul>
          <li>{t(BID_SEC_LI1)}</li>
          <li>{t(BID_SEC_LI2)}</li>
          <li>{t(BID_SEC_LI3)}</li>
          <li>{t(BID_SEC_LI4)}</li>
          <li>{t(BID_SEC_LI5)}</li>
          <li>{t(BID_SEC_LI6)}</li>
          <li>{t(BID_SEC_LI7)}</li>
          <li>{t(BID_SEC_LI8)}</li>
        </ul>
      </div>
    </div>
  );
}

export default BidSection;
